import type { Observable } from 'rxjs'
import { of, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

/**
 * Suppresses errors caused by request cancellation (AbortController /
 * unsubscribing).
 *
 * We see these in browsers as `AbortError: signal is aborted without reason`
 * when an in-flight Apollo/Http request is cancelled during component
 * teardown.
 */
export function ignoreAbortError<T>(
  fallbackValue: T
): (source$: Observable<T>) => Observable<T> {
  return source$ =>
    source$.pipe(
      catchError((err: unknown) => {
        const e = err as { name?: string; message?: string } | null | undefined
        const name = e?.name

        const isAbort =
          name === 'AbortError' ||
          (typeof e?.message === 'string' &&
            e.message.includes('signal is aborted'))

        return isAbort ? of(fallbackValue) : throwError(() => err)
      })
    )
}
